import React, { useState } from 'react';
import { Task, PhysicalUnit, Level, ProjectInfo, ProtocolState, WeeklyPlan, Responsible } from '../../types';
import { GraphicProgressTaskView } from './GraphicProgressTaskView';
import { GraphicProgressPlanningView } from './GraphicProgressPlanningView';

export interface GraphicProgressViewerProps {
    activeProjectId: string;
    tasks: Task[];
    units: PhysicalUnit[];
    levels: Level[];
    matrixData: Record<string, any>;
    protocolConfigs: any;
    projectInfo: ProjectInfo;
    savedProtocols: Record<string, ProtocolState>;
    weeklyPlans: WeeklyPlan[];
    responsibles?: Responsible[];
    selectedTaskId?: string | null;
    activePlanId?: number | null;
    initialMode?: 'task' | 'planning';
    isFullscreen?: boolean;
    onToggleFullscreen?: () => void;
    onClose?: () => void;
}

export const GraphicProgressViewer: React.FC<GraphicProgressViewerProps> = ({
    activeProjectId,
    tasks,
    units,
    levels,
    matrixData,
    protocolConfigs,
    projectInfo,
    savedProtocols,
    weeklyPlans,
    responsibles = [],
    selectedTaskId,
    activePlanId,
    initialMode = 'planning',
    isFullscreen,
    onToggleFullscreen,
    onClose
}) => {
    const [viewerMode, setViewerMode] = useState<'task' | 'planning'>(initialMode);

    React.useEffect(() => {
        if (initialMode) {
            setViewerMode(initialMode);
        }
    }, [initialMode]);

    return (
        <div className="flex flex-col h-full w-full relative overflow-hidden">
            {/* Contenido según el modo */}
            <div className="flex-1 min-h-0 w-full h-full overflow-hidden">
                {viewerMode === 'planning' ? (
                    <GraphicProgressPlanningView
                        activeProjectId={activeProjectId}
                        tasks={tasks}
                        units={units}
                        levels={levels}
                        matrixData={matrixData}
                        protocolConfigs={protocolConfigs}
                        projectInfo={projectInfo}
                        savedProtocols={savedProtocols}
                        weeklyPlans={weeklyPlans}
                        responsibles={responsibles}
                        activePlanId={activePlanId}
                        isFullscreen={isFullscreen}
                        onToggleFullscreen={onToggleFullscreen}
                        onClose={onClose}
                    />
                ) : (
                    <GraphicProgressTaskView
                        activeProjectId={activeProjectId}
                        tasks={tasks}
                        units={units}
                        levels={levels}
                        matrixData={matrixData}
                        protocolConfigs={protocolConfigs}
                        projectInfo={projectInfo}
                        savedProtocols={savedProtocols}
                        weeklyPlans={weeklyPlans}
                        selectedTaskId={selectedTaskId}
                        activePlanId={activePlanId}
                        onClose={onClose}
                    />
                )}
            </div>
        </div>
    );
};
